import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BoxService } from 'src/app/service/box.service';
import { Box } from './box';

@Component({
  selector: 'app-box-form',
  templateUrl: './box-form.component.html',
  styleUrls: ['./box.component.scss'],
})
export class BoxFormComponent implements OnInit {

  formulario: FormGroup;
  carregando = false;

  constructor(
    private boxService: BoxService,
    private formBilder: FormBuilder,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.montarFormulario();
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.carregar(+id);
    }
  }

  submit() {
    const formValues = this.formulario.value;
    const box: Box = new Box(
      formValues.id,
      formValues.name,
      formValues.pixBalance,
      formValues.caixaBalance,
      formValues.cartaoBalance,
      formValues.createdAt,
      formValues.active,
    );

    if (formValues.id) {
      this.boxService.update(box).subscribe(() => {
        this.snackBar.open('Caixa alterado com sucesso!', 'Sucesso', {
          duration: 2000,
        });
        this.voltarConsulta();
      }, errorResponse => {
        this.snackBar.open(errorResponse.error.message, 'ERRO', {
          duration: 2000,
        });
      });
    } else {
      this.boxService.save(box).subscribe(() => {
        this.snackBar.open('Caixa salvo com sucesso!', 'Sucesso', {
          duration: 2000,
        });
        this.voltarConsulta();
      }, errorResponse => {
        this.snackBar.open(errorResponse.error.message, 'ERRO', {
          duration: 2000,
        });
      });
    }
  }

  montarFormulario() {
    this.formulario = this.formBilder.group({
      id: [null, Validators.nullValidator],
      name: [null, [Validators.minLength(3), Validators.maxLength(250)]],
      pixBalance: [null, Validators.nullValidator],
      caixaBalance: [null, Validators.nullValidator],
      cartaoBalance: [null, Validators.nullValidator],
      createdAt: [null, Validators.nullValidator],
      active: [null, Validators.nullValidator],
    });
  }

  carregar(id: number) {
    this.carregando = true;
    this.boxService.findClientById(id).subscribe((response) => {
      this.formulario.controls.id.setValue(id);
      this.formulario.controls.name.setValue(response.name);
      this.formulario.controls.pixBalance.setValue(response.pixBalance);
      this.formulario.controls.caixaBalance.setValue(response.caixaBalance);
      this.formulario.controls.cartaoBalance.setValue(response.cartaoBalance);
      this.formulario.controls.createdAt.setValue(response.createdAt);
      this.formulario.controls.active.setValue(response.active);
      this.carregando = false;
    }, () => {
      this.carregando = false;
      this.snackBar.open('Caixa não encontrado.', 'ERRO', { duration: 2500 });
      this.voltarConsulta();
    });
  }

  limpar() {
    this.router.navigate(['/box/form']);
    this.montarFormulario();
  }

  voltarConsulta() {
    this.router.navigate(['/box/consulta']);
  }
}
